import h from 'underscore.string/humanize';

const humanize = (string: string) => {
  return h(string);
};

export default humanize;
